import { z } from 'zod'

export const ADMINFORMSMODULESPATCH_CONTRACT_VERSION = '1.0.0' as const
export const adminFormsModulesPatchResponseSchema = z.unknown()
export type AdminFormsModulesPatchResponse = z.infer<typeof adminFormsModulesPatchResponseSchema>
